import * as React from 'react'
import { FC } from 'react'

import './TitleText.scss'

interface Props {
    title: string
    children?: React.ReactNode
}

const TitleText: FC<Props> = ({ title, children }) => {
    return (
        <article className="TitleText typo">
            <h2>{title}</h2>
            {children}
        </article>
    )
}

export default TitleText
